<template>
  <div class="v-table-filter__wrapper">
    <VInput
      icon="search"
      iconPosition="right"
      placeholder="Search..."
      classType="primary"
      iconFABase="fal"
      name="filter"
      :value="searchString"
      @input="_onFilter"
      extraClass="v-table-filter"
    ></VInput>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import VInput from "@/components/VInput";

export default Vue.component("VTableSearch", {
  props: {
    searchString: VueTypes.string
  },

  components: {
    VInput
  },

  methods: {
    _onFilter(searchString) {
      this.$emit("filter", searchString);
    }
  }
});
</script>

<style lang="scss">
.v-table-filter__wrapper {
  margin-left: 30px;
}

.v-table-filter.primary {
  .right {
    flex-direction: row-reverse;

    .icon-wrapper {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }

  input {
    width: 270px;
    height: $input-height;
    line-height: normal;

    &,
    &::placeholder {
      font-size: 15px;
    }

    &::placeholder {
      color: #4e4e4e;
      font-family: "Lato-Light", Arial, sans-serif;
      font-style: italic;
    }
  }

  .input-icon__wrapper.right {
    height: $input-height;
    border-radius: 3px;

    i {
      font-size: 14px;
      color: #231f20;
    }

    .icon-wrapper.focused i {
      color: $primary-color;
    }

    .icon-wrapper {
      height: 30px;
    }
  }
}
</style>
